module.exports = __webpack_public_path__ + "img/19_l.543b7dcd.jpg";